import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../LinkyLinky';
import Modal from '../../../../../../../Modal';
import ModalStore from '../../../../../../../Modal/Store';
import { LearningCollectionResource } from '../../../../../../Types';
import InviteParticipantStore from '../../../Store';
import { SelectParticipantsState } from '../../../Types';
import Body from './Body';
import Header from './Header';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionResource: LearningCollectionResource;
  state: SelectParticipantsState;
}

function ReadyModal({ modalStore, store, learningCollectionResource, state }: Props) {
  return findLink('options', learningCollectionResource.links)
    .map((link) => (
      <Modal
        close={modalStore.close}
        title={<Header />}
        customBackgroundCssClasses="bg-teal-100 opacity-60"
        modalWidth="w-2/5"
      >
        <Body
          link={link}
          store={store}
          learningCollectionResource={learningCollectionResource}
          state={state}
        />
      </Modal>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ReadyModal);
